$('.odv_symbol_img').each(function() {
    if (this.complete && typeof this.naturalWidth !== "undefined" && this.naturalWidth === 0) {
      $(this).hide();
    }
  });

var odv_button_loaded = setInterval(function () {
        if(jQuery(".headfont").text().includes("Valentinstag-Set Buchstabe") || jQuery(".headfont").text().includes("Fußkettchen Buchstabe") || jQuery(".headfont").text().includes("Fußkette Buchstabe")) {
            jQuery(".inputwrapper-kettengröße[val='A']").click();
            jQuery("span#dropdown-name1").html("Buchstabe");
            jQuery("fieldset.js.product-form__input.armkette-buchstabe.kettenlänge").css("background-color", "#fff");
            clearInterval(odv_button_loaded);
            jQuery(".odv_symbol_img").show();
        }
}, 1000);


jQuery(".product-form__input.buchstabe .inputwrapper-kettengröße").click(function(){
      var act_letter = jQuery(this).attr('val');
console.log(act_letter);
  $(".buchstabe .dropdown-name").text(act_letter);
  $(".gutschein").css("background", "#F2D4C260");
} );

jQuery("#armkette-buchstabe fieldset.js.product-form__input.buchstabe .inputwrapper-kettengröße").click(function() {
    var act_letter = jQuery(this).attr('val');
    jQuery(".odv_symbol_img").each(function() {
        var old_img_src = jQuery(this).attr('src');
        var new_img_src = old_img_src.split('_')[0];
        new_img_src += "_" + act_letter + "_Buchstabe.png";
        jQuery(this).attr('src', new_img_src);
    });
});


jQuery("#fusskette-buchstabe-925-sterling-silber fieldset.js.product-form__input.buchstabe .inputwrapper-kettengröße").click(function() {
    var act_letter = jQuery(this).attr('val');
    jQuery(".odv_symbol_img").each(function() {
        var old_img_src = jQuery(this).attr('src');
        var new_img_src = old_img_src.split('_')[0];
        new_img_src += "_" + act_letter + "_Buchstabe.png";
        jQuery(this).attr('src', new_img_src);
    });
});

jQuery(".armband-buchstabe-produkt fieldset.js.product-form__input.buchstabe .inputwrapper-kettengröße").click(function() {
    jQuery(".armband-buchstabe-produkt .dropdown-content-bandgröße").hide();
    var act_letter = jQuery(this).attr('val');
    jQuery(".odv_symbol_img").each(function() {
        var old_img_src = jQuery(this).attr('src');
        var new_img_src = old_img_src.split('_')[0];
        new_img_src += "_" + act_letter + "_Buchstabe.png";
        jQuery(this).attr('src', new_img_src);
    });
    
});

jQuery(".kette-mit-buchstaben fieldset.js.product-form__input.buchstabe .inputwrapper-kettengröße").click(function() {
    var act_letter = jQuery(this).attr('val');
    jQuery(".odv_symbol_img").each(function() {
        var old_img_src = jQuery(this).attr('src');
        var new_img_src = old_img_src.split('_')[0];
        new_img_src += "_" + act_letter + "_Kette_Buchstabe.png";
        jQuery(this).attr('src', new_img_src);
    });
});

jQuery(".kette-mit-buchstaben .dropdown-content-bandgröße .inputwrapper-kettengröße").click(function(){
    jQuery(".kette-mit-buchstaben .dropdown-bandgröße #dropdown-name1").html(jQuery(this).attr("val"));
    });
    jQuery(".kette-mit-buchstaben.new_product .dropdown-content-bandgröße .inputwrapper-kettengröße").click(function(){
    jQuery(".dropdown-bandgröße #dropdown-name1").html(jQuery(this).attr("val"));
    console.log(jQuery(this).attr("val"));
    jQuery(this).parent().parent().parent().addClass("active-bg");
});

jQuery(".armkette-buchstabe .dropdown-content-bandgröße .inputwrapper-kettengröße").click(function(){
    jQuery(".armkette-buchstabe .dropdown-bandgröße #dropdown-name1").html(jQuery(this).attr("val"));
    });
    jQuery(".material-band.new_product .dropdown-content-bandgröße .inputwrapper-kettengröße").click(function(){
    jQuery(".dropdown-bandgröße #dropdown-name2").html(jQuery(this).attr("val"));
    jQuery(this).parent().parent().parent().addClass("active-bg");
});
jQuery("#valentinstag-set-buchstabe-armband-halskette fieldset.js.product-form__input.armkette-buchstabe.kettenlänge .inputwrapper-kettengröße").click(function() {
    var act_letter = jQuery(this).attr('val');
    jQuery(".odv_symbol_img").each(function() {
        var old_img_src = jQuery(this).attr('src');
        var new_img_src = old_img_src.split('_')[0];
        new_img_src += "_" + act_letter + "_Buchstabe.png";
        jQuery(this).attr('src', new_img_src);
    });
    });

    jQuery(".armkette-buchstabe .dropdown-content-bandgröße .inputwrapper-kettengröße").click(function(){
    jQuery(".armkette-buchstabe .dropdown-bandgröße #dropdown-name1").html(jQuery(this).attr("val"));
});

jQuery("#valentinstag-set-buchstabe-armkette-halskette fieldset.js.product-form__input.armkette-buchstabe.kettenlänge .inputwrapper-kettengröße").click(function() {
    var act_letter = jQuery(this).attr('val');
    jQuery(".odv_symbol_img").each(function() {
        var old_img_src = jQuery(this).attr('src');
        var new_img_src = old_img_src.split('_')[0];
        var material = "";
        if (jQuery(this).parent().hasClass("Silber")) {
            var material = "Silber"
        } else if (jQuery(this).parent().hasClass("Gold")) {
            var material = "Gold";
        } else if (jQuery(this).parent().hasClass("Rose")) {
            var material = "Rose";
        }
        new_img_src += "_" + material + "_" + act_letter + "_Buchstabe.png";
        jQuery(this).attr('src', new_img_src);
    });
    });

    jQuery(".armkette-buchstabe .dropdown-content-bandgröße .inputwrapper-kettengröße").click(function(){
    jQuery(".armkette-buchstabe .dropdown-bandgröße #dropdown-name1").html(jQuery(this).attr("val"));
});

jQuery(".ringsize-swatches .avp-productoptionswatchwrapper").click(function(){
    var ringsize = jQuery(".avp-productoptionswatchwrapper .activeletter").html();
    jQuery("#ringsize").html(ringsize);
    jQuery("#ringsizewrapper").css("background-color","#F2D4C260");
});
jQuery("#dropdown-bandgröße-0 .inputwrapper-bandgröße").click(function(){
    jQuery("#dropdown-bandgröße-0 .dropdown-wrapper").css("background-color","#F2D4C260");
});
jQuery("#dropdown-bandgröße-1 .inputwrapper-bandgröße").click(function(){
    jQuery("#dropdown-bandgröße-1 .dropdown-wrapper").css("background-color","#F2D4C260");
});
jQuery(".ringstone-swatches .avp-productoptionswatchwrapper").click(function(){
    var ringstone = jQuery("div.ringstone-choice").text().split(" ");
    jQuery("#ringstone").html(ringstone[0]);
    jQuery("#ringstonewrapper").css("background-color","#F2D4C260");
});
jQuery(".ringsymbol-swatches .avp-productoptionswatchwrapper").click(function(){
    var ringssymbol = jQuery(".ringsymbol-choice").html();
    jQuery("#ringsymbol").html(ringssymbol);
    jQuery("#ringsymbolwrapper").css("background-color","#F2D4C260");
});
jQuery(".ringfont-swatches .avp-productoptionswatchwrapper").click(function(){
    var ringfont = jQuery(".ringfont-choice").html();
    jQuery("#ringfont").html(ringfont);
    jQuery("#ringfontwrapper").css("background-color","#F2D4C260");
});


jQuery(".inputwrapper-kettengröße[val='40 cm']").click(function(){
    if (jQuery(".headfont").html().indexOf("Valentinstag") != 0 ) {
    jQuery(".kettenlänge .dropdown-wrapper #dropdown-name2").html("40 cm");
    jQuery(".kettenlänge").css("background-color","#F2D4C260");
    } else {
      jQuery(".kettenlänge.odv_js .dropdown-wrapper #dropdown-name2").html("40 cm");
      jQuery(".kettenlänge.odv_js").css("background-color","#F2D4C260");
    }
  });
  jQuery(".inputwrapper-kettengröße[val='45 cm']").click(function(){
    if (jQuery(".headfont").html().indexOf("Valentinstag") != 0 ) {
    jQuery(".kettenlänge .dropdown-wrapper #dropdown-name2").html("45 cm");
    jQuery(".kettenlänge").css("background-color","#F2D4C260");
    } else {
      jQuery(".kettenlänge.odv_js .dropdown-wrapper #dropdown-name2").html("45 cm");
      jQuery(".kettenlänge.odv_js").css("background-color","#F2D4C260");
    }
  });
jQuery(".inputwrapper-kettengröße[val='40 cm']").click(function(){
    if (jQuery(".headfont").html().indexOf("Valentinstag") != 0 ) {
    jQuery(".kettenlänge .dropdown-wrapper #dropdown-name1").html("40 cm");
    jQuery(".kettenlänge").css("background-color","#F2D4C260");
    } else {
      jQuery(".kettenlänge.odv_js .dropdown-wrapper #dropdown-name1").html("40 cm");
      jQuery(".kettenlänge.odv_js").css("background-color","#F2D4C260");
    }
  });
jQuery(".inputwrapper-kettengröße[val='45 cm']").click(function(){
    if (jQuery(".headfont").html().indexOf("Valentinstag") != 0 ) {
    jQuery(".kettenlänge .dropdown-wrapper #dropdown-name1").html("45 cm");
    jQuery(".kettenlänge").css("background-color","#F2D4C260");
    } else {
      jQuery(".kettenlänge.odv_js .dropdown-wrapper #dropdown-name1").html("45 cm");
      jQuery(".kettenlänge.odv_js").css("background-color","#F2D4C260");
    }
  });
  jQuery(".inputwrapper-kettengröße[val='40 cm']").click(function(){
    jQuery(".kettenlänge .dropdown-wrapper #dropdown-name0").html("40 cm");
    jQuery(".kettenlänge.odv_js").css("background-color","#F2D4C260");
  });
jQuery(".inputwrapper-kettengröße[val='45 cm']").click(function(){
    jQuery(".kettenlänge .dropdown-wrapper #dropdown-name0").html("45 cm");
    jQuery(".kettenlänge.odv_js").css("background-color","#F2D4C260");
  });
  jQuery(".inputwrapper-kettengröße[val='Damen']").click(function(){
    jQuery(".bandgröße .dropdown-wrapper .dropdown-name").html("Damen");
    jQuery(".bandgröße").css("background-color","#F2D4C260");
  });
jQuery(".inputwrapper-kettengröße[val='Herren']").click(function(){
    jQuery(".bandgröße .dropdown-wrapper .dropdown-name").html("Herren");
    jQuery(".bandgröße").css("background-color","#F2D4C260");
  });
  jQuery(".inputwrapper-kettengröße[val='3-8 Jahre']").click(function(){
    jQuery(".bandgröße .dropdown-wrapper .dropdown-name").html("3-8 Jahre");
    jQuery(".bandgröße").css("background-color","#F2D4C260");
  });
jQuery(".inputwrapper-kettengröße[val='8-12 Jahre']").click(function(){
    jQuery(".bandgröße .dropdown-wrapper .dropdown-name").html("8-12 Jahre");
    jQuery(".bandgröße").css("background-color","#F2D4C260");
  });
  jQuery(".inputwrapper-kettengröße[optionname='Buchstabe']").click(function(){
    //jQuery(".buchstabe .dropdown-wrapper .dropdown-name").html(jQuery(this).attr("val"));
    jQuery(".buchstabe").css("background-color","#F2D4C260");
});

jQuery(".inputwrapper-kettengröße[optionname='Buchstabe']").click(function(){
    if (jQuery(".headfont").html().indexOf("Valentinstag") == 0 ) {
    jQuery(".kettenlänge.armkette-buchstabe").css("background-color","#F2D4C260");
    }
  });

  jQuery(".inputwrapper-kettengröße[val='Damen']").click(function(){
    if (jQuery(".headfont").html().indexOf("Valentinstag") == 0 ) {
    jQuery(".kettenlänge .dropdown-wrapper #dropdown-name2").html("Damen");
    jQuery(".kettenlänge").css("background-color","#F2D4C260");
    }
  });

  jQuery(".inputwrapper-kettengröße[val='Herren']").click(function(){
    if (jQuery(".headfont").html().indexOf("Valentinstag") == 0 ) {
    jQuery(".kettenlänge .dropdown-wrapper #dropdown-name2").html("Herren");
    jQuery(".kettenlänge").css("background-color","#F2D4C260");
    }
  });

jQuery("#product_reviews").click(function(){
    jQuery(".ElementsWidget-prefix").show();
  });

jQuery(".odv_bewertungen summary").click(function(){
    jQuery(".ElementsWidget-prefix").toggle();
  });

  jQuery(".inputwrapper-kettengröße input").click(function(){
    jQuery(".armband-buchstabe-produkt .dropdown-content-bandgröße").hide();
  });

var material_interval = setInterval(function() {
    if(jQuery(".odv_buchstaben_switch span.dropdown-name").html() != undefined) {
        if(jQuery(".odv_buchstaben_switch span.dropdown-name").html().indexOf("Silber") >= 0) {
            jQuery(".odv_material_text").html("925er Sterlingsilber, nickelfrei");
            jQuery(".odv_material_banner").css("background-color", "#c0c0c0");
            jQuery(".odv_material_text").css("color", "#121212b3");
        } else if (jQuery(".odv_buchstaben_switch span.dropdown-name").html().indexOf("gelb vergoldet") >= 0) {
            jQuery(".odv_material_text").html("feinvergoldet, nickelfrei");
            jQuery(".odv_material_banner").css("background-color", "#F2DD35");
            jQuery(".odv_material_text").css("color", "#121212b3");
        } else if (jQuery(".odv_buchstaben_switch span.dropdown-name").html().indexOf("rosé vergoldet") >= 0) {
            jQuery(".odv_material_text").html("rosé vergoldet, nickelfrei");
            jQuery(".odv_material_banner").css("background-color", "#f2d4c2");
            jQuery(".odv_material_text").css("color", "#121212b3");
        } else {
            jQuery(".odv_material_text").css("font-size", "0");
        }
    } else {
    if(jQuery('input[value=Silber]').is(':checked')) {
        jQuery(".odv_material_text").html("925er Sterlingsilber, nickelfrei");
        jQuery(".odv_material_banner").css("background-color", "#c0c0c0");
        jQuery(".odv_material_text").css("color", "#121212b3");
    } else if (jQuery('input[value=Gold]').is(':checked') ) {
        jQuery(".odv_material_text").html("feinvergoldet, nickelfrei");
        jQuery(".odv_material_banner").css("background-color", "#F2DD35");
        jQuery(".odv_material_text").css("color", "#121212b3");
    } else if (jQuery('input[value=Rosé]').is(':checked') ) {
        jQuery(".odv_material_text").html("rosé vergoldet, nickelfrei");
        jQuery(".odv_material_banner").css("background-color", "#f2d4c2");
        jQuery(".odv_material_text").css("color", "#121212b3");
    } else {
        jQuery(".odv_material_text").css("font-size", "0");
    }
    }
}, 500);

if(jQuery("h1.headfont.mobile_rm").html().indexOf("Armband - Buchstabe") >= 0) {
    if (jQuery("h1.headfont.mobile_rm").html().indexOf("Silber") >= 0) {
        jQuery(".odv_material_banner").css("background-color", "#C0C0C0");
    } else if (jQuery("h1.headfont.mobile_rm").html().indexOf("Gold") >= 0) {
        jQuery(".odv_material_banner").css("background-color", "#F2DD35");
    } else if (jQuery("h1.headfont.mobile_rm").html().indexOf("Rosé") >= 0) {
        jQuery(".odv_material_banner").css("background-color", "#F2D4C2");
    }
}

/* SELECTED BORDER MATERIAL BUTTONS */
if (document.getElementById("Silberlabel") !== null) {
  document.getElementById("Silberlabel").classList.add("activebutton");
}
var _learnq = _learnq || [];
document.getElementById("AddToCart").addEventListener('click',function (){
     _learnq.push(['track', 'Added to Cart', item]);
});
function materialclickGold() {
  if (document.getElementById("Goldlabel") != undefined) {
      document.getElementById("Goldlabel").classList.add("activebutton");
  }
  if (document.getElementById("Silberlabel") != undefined) {
      document.getElementById("Silberlabel").classList.remove("activebutton");
  }
  if (document.getElementById("Rosélabel") != undefined) {
      document.getElementById("Rosélabel").classList.remove("activebutton");
  }
  if (jQuery('img[data-var-title="' + jQuery(".activebutton").parent().attr("id") + ' / ' + jQuery("#dropdown-name1").text() + '"]').parent().attr("data-nr")) {
      /* ring removal
      if (window.location.href.includes("ring-edition")) {
          setRingProductImage();
      } else {*/
          swiper2.slideTo(jQuery('img[data-var-title="' + jQuery(".activebutton").parent().attr("id") + ' / ' + jQuery("#dropdown-name1").text() + '"]').parent().attr("data-nr"), 0);
      //}
  } else {
      /* ring removal
      if (window.location.href.includes("ring-edition")) {
          setRingProductImage();
      } else { */
          swiper2.slideTo(jQuery('.swiper-slide[data-var="Gold"]').attr("data-nr"), 0)
      //}
  }
  if (jQuery(".product").hasClass("new_product")) {
    if(jQuery("h1.headfont.mobile_rm").html().indexOf("Sternzeichen") >= 0 || jQuery("h1.headfont.mobile_rm").html().indexOf("Armband") >= 0 || jQuery("h1.headfont.mobile_rm").html().indexOf("Fußkette") >= 0  || jQuery("h1.headfont.mobile_rm").html().indexOf("Fußkettchen") >= 0|| jQuery("h1.headfont.mobile_rm").html().indexOf("Kette") >= 0 || jQuery("h1.headfont.mobile_rm").html().indexOf("Armkette") >= 0 || jQuery("h1.headfont.mobile_rm").html().indexOf("Valentinstag") >= 0 ) {
    jQuery(".swiper-slide[data-var='Gold']").removeClass("swiper-slide-active");
    jQuery(".swiper-slide[data-var='Gold']").removeClass("swiper-slide-prev");
    jQuery(".swiper-slide[data-var='Gold']").removeClass("swiper-slide-next");
  
    jQuery(".swiper-slide[data-var='Silber']").removeClass("swiper-slide-active");
    jQuery(".swiper-slide[data-var='Silber']").removeClass("swiper-slide-prev");
    jQuery(".swiper-slide[data-var='Silber']").removeClass("swiper-slide-next");
  
    jQuery(".swiper-slide[data-var='Rosé']").removeClass("swiper-slide-active");
    jQuery(".swiper-slide[data-var='Rosé']").removeClass("swiper-slide-prev");
    jQuery(".swiper-slide[data-var='Rosé']").removeClass("swiper-slide-next");

    jQuery(".odv_extra_icon").removeClass("swiper-slide-active");
    jQuery(".odv_extra_icon").removeClass("swiper-slide-prev");
    jQuery(".odv_extra_icon").removeClass("swiper-slide-next");

    jQuery(".odv_extra_icon_2").removeClass("swiper-slide-active");
    jQuery(".odv_extra_icon_2").removeClass("swiper-slide-prev");
    jQuery(".odv_extra_icon_2").removeClass("swiper-slide-next");

    jQuery(".odv_extra_icon_3").removeClass("swiper-slide-active");
    jQuery(".odv_extra_icon_3").removeClass("swiper-slide-prev");
    jQuery(".odv_extra_icon_3").removeClass("swiper-slide-next");

    jQuery(".swiper-slide[data-var='Gold']").addClass("swiper-slide-active");
    jQuery(".swiper-slide[data-var='Silber']").addClass("swiper-slide-prev");
    jQuery(".swiper-slide[data-var='Rosé']").addClass("swiper-slide-next");
    jQuery(".swiper-button-prev").click();
    }
}
  if (jQuery("#dropdown-name1").html() != "Nude") {
    var gold_interval =  setInterval(function() {
        jQuery(".inputwrapper[val='" + jQuery('#dropdown-name1').html() + "']").click();
        clearInterval(gold_interval);
    }, 50);
  }
}

function materialclickSilber() {
  if (document.getElementById("Goldlabel") != undefined) {
      document.getElementById("Goldlabel").classList.remove("activebutton");
  }
  if (document.getElementById("Silberlabel") != undefined) {
      document.getElementById("Silberlabel").classList.add("activebutton");
  }
  if (document.getElementById("Rosélabel") != undefined) {
      document.getElementById("Rosélabel").classList.remove("activebutton");
  }
  /* ring removal
  if (window.location.href.includes("ring-edition")) {
      setRingProductImage();
  } else*/
  if (jQuery('img[data-var-title="' + jQuery(".activebutton").parent().attr("id") + ' / ' + jQuery("#dropdown-name1").text() + '"]').parent().attr("data-nr")) {
      swiper2.slideTo(jQuery('img[data-var-title="' + jQuery(".activebutton").parent().attr("id") + ' / ' + jQuery("#dropdown-name1").text() + '"]').parent().attr("data-nr"), 0);
  } else {
      swiper2.slideTo(jQuery('.swiper-slide[data-var="Silber"]').attr("data-nr"), 0)
  }
  if (jQuery(".product").hasClass("new_product")) {
  if(jQuery("h1.headfont.mobile_rm").html().indexOf("Sternzeichen") >= 0  || jQuery("h1.headfont.mobile_rm").html().indexOf("Fußkette") >= 0 || jQuery("h1.headfont.mobile_rm").html().indexOf("Fußkettchen") >= 0|| jQuery("h1.headfont.mobile_rm").html().indexOf("Armband") >= 0 || jQuery("h1.headfont.mobile_rm").html().indexOf("Kette") >= 0 || jQuery("h1.headfont.mobile_rm").html().indexOf("Armkette") >= 0 || jQuery("h1.headfont.mobile_rm").html().indexOf("Valentinstag") >= 0 ) {
    jQuery(".swiper-slide[data-var='Gold']").removeClass("swiper-slide-active");
    jQuery(".swiper-slide[data-var='Gold']").removeClass("swiper-slide-prev");
    jQuery(".swiper-slide[data-var='Gold']").removeClass("swiper-slide-next");
  
    jQuery(".swiper-slide[data-var='Silber']").removeClass("swiper-slide-active");
    jQuery(".swiper-slide[data-var='Silber']").removeClass("swiper-slide-prev");
    jQuery(".swiper-slide[data-var='Silber']").removeClass("swiper-slide-next");
  
    jQuery(".swiper-slide[data-var='Rosé']").removeClass("swiper-slide-active");
    jQuery(".swiper-slide[data-var='Rosé']").removeClass("swiper-slide-prev");
    jQuery(".swiper-slide[data-var='Rosé']").removeClass("swiper-slide-next");

    jQuery(".odv_extra_icon").removeClass("swiper-slide-active");
    jQuery(".odv_extra_icon").removeClass("swiper-slide-prev");
    jQuery(".odv_extra_icon").removeClass("swiper-slide-next");

    jQuery(".odv_extra_icon_2").removeClass("swiper-slide-active");
    jQuery(".odv_extra_icon_2").removeClass("swiper-slide-prev");
    jQuery(".odv_extra_icon_2").removeClass("swiper-slide-next");

    jQuery(".odv_extra_icon_3").removeClass("swiper-slide-active");
    jQuery(".odv_extra_icon_3").removeClass("swiper-slide-prev");
    jQuery(".odv_extra_icon_3").removeClass("swiper-slide-next");
  
    jQuery(".swiper-slide[data-var='Silber']").addClass("swiper-slide-active");
    jQuery(".swiper-slide[data-var='Gold']").addClass("swiper-slide-next");
    jQuery(".swiper-button-prev").click();
    jQuery(".swiper-button-prev").click();
    }
}
    if (jQuery("#dropdown-name1").html() != "Nude") {
        var silber_interval =  setInterval(function() {
            jQuery(".inputwrapper[val='" + jQuery('#dropdown-name1').html() + "']").click();
            clearInterval(silber_interval);
        }, 50);
      
      }
}

function materialclickRosé() {
  if (document.getElementById("Goldlabel") != undefined) {
      document.getElementById("Goldlabel").classList.remove("activebutton");
  }
  if (document.getElementById("Silberlabel") != undefined) {
      document.getElementById("Silberlabel").classList.remove("activebutton");
  }
  if (document.getElementById("Rosélabel") != undefined) {
      document.getElementById("Rosélabel").classList.add("activebutton");
  }
  /* ring removal
  if (window.location.href.includes("ring-edition")) {
      setRingProductImage();
  } else*/ if (jQuery('img[data-var-title="' + jQuery(".activebutton").parent().attr("id") + ' / ' + jQuery("#dropdown-name1").text() + '"]').parent().attr("data-nr")) {
      swiper2.slideTo(jQuery('img[data-var-title="' + jQuery(".activebutton").parent().attr("id") + ' / ' + jQuery("#dropdown-name1").text() + '"]').parent().attr("data-nr"), 0);
  } else {
      swiper2.slideTo(jQuery('.swiper-slide[data-var="Rosé"]').attr("data-nr"), 0)
  }
  if (jQuery(".product").hasClass("new_product")) {
  if(jQuery("h1.headfont.mobile_rm").html().indexOf("Sternzeichen") >= 0  || jQuery("h1.headfont.mobile_rm").html().indexOf("Fußkette") >= 0  || jQuery("h1.headfont.mobile_rm").html().indexOf("Fußkettchen") >= 0|| jQuery("h1.headfont.mobile_rm").html().indexOf("Armband") >= 0 || jQuery("h1.headfont.mobile_rm").html().indexOf("Kette") >= 0 || jQuery("h1.headfont.mobile_rm").html().indexOf("Armkette") >= 0 || jQuery("h1.headfont.mobile_rm").html().indexOf("Valentinstag") >= 0) {
 
    jQuery(".swiper-slide[data-var='Gold']").removeClass("swiper-slide-active");
    jQuery(".swiper-slide[data-var='Gold']").removeClass("swiper-slide-prev");
    jQuery(".swiper-slide[data-var='Gold']").removeClass("swiper-slide-next");
  
    jQuery(".swiper-slide[data-var='Silber']").removeClass("swiper-slide-active");
    jQuery(".swiper-slide[data-var='Silber']").removeClass("swiper-slide-prev");
    jQuery(".swiper-slide[data-var='Silber']").removeClass("swiper-slide-next");
  
    jQuery(".swiper-slide[data-var='Rosé']").removeClass("swiper-slide-active");
    jQuery(".swiper-slide[data-var='Rosé']").removeClass("swiper-slide-prev");
    jQuery(".swiper-slide[data-var='Rosé']").removeClass("swiper-slide-next");

    jQuery(".odv_extra_icon").removeClass("swiper-slide-active");
    jQuery(".odv_extra_icon").removeClass("swiper-slide-prev");
    jQuery(".odv_extra_icon").removeClass("swiper-slide-next");

    jQuery(".odv_extra_icon_2").removeClass("swiper-slide-active");
    jQuery(".odv_extra_icon_2").removeClass("swiper-slide-prev");
    jQuery(".odv_extra_icon_2").removeClass("swiper-slide-next");

    jQuery(".odv_extra_icon_3").removeClass("swiper-slide-active");
    jQuery(".odv_extra_icon_3").removeClass("swiper-slide-prev");
    jQuery(".odv_extra_icon_3").removeClass("swiper-slide-next");
  
    jQuery(".swiper-slide[data-var='Rosé']").addClass("swiper-slide-active");
    jQuery(".swiper-slide[data-var='Gold']").addClass("swiper-slide-prev");
    if(jQuery("h1.headfont.mobile_rm").html().indexOf("Sternzeichen") >= 0) {
        jQuery(".odv_extra_icon_3").addClass("swiper-slide-next");
    } else {
        jQuery(".odv_extra_icon").addClass("swiper-slide-next");
    }
    jQuery(".swiper-button-prev").click();
    }
}
    if (jQuery("#dropdown-name1").html() != "Nude") {
        var rose_interval =  setInterval(function() {
            jQuery(".inputwrapper[val='" + jQuery('#dropdown-name1').html() + "']").click();
            clearInterval(rose_interval);
        }, 50);
      }
}


/* FUNCTIONS GET & SET COLOR BANDFARBE */

function getColorName() {
  var colorlist = document.getElementsByClassName("bfarbe");
  for (let i = 0; i < colorlist.length; i++) {
      var color = colorlist[i].innerHTML;
      switch (color) {
          case "Regenbogen":
              document.getElementById(color).style.background = "linear-gradient(to right,blue, red , yellow, green)";
              break;
          case "Nude":
              document.getElementById(color).style.background = "#E5D2C4";
              break;
          case "Altrosa":
              document.getElementById(color).style.background = "#cb7375";
              break;
          case "Dunkelgrau":
              document.getElementById(color).style.background = "#797b7a";
              break;
          case "Hellgrau":
              document.getElementById(color).style.background = "#C6C6C6";
              break;
         case "Blau":
                document.getElementById(color).style.background = "#3E4E74";
                break;    
          case "Dunkelblau":
              document.getElementById(color).style.background = "#3E4E74";
              break;
          case "Hellblau":
              document.getElementById(color).style.background = "#8FABED";
              break;
          case "Neonblau":
              document.getElementById(color).style.background = "#0333A5";
              break;
          case "Türkis":
              document.getElementById(color).style.background = "#1CB4C1";
              break;
          case "Schwarz":
              document.getElementById(color).style.background = "#000000";
              break;
          case "Anthrazit":
              document.getElementById(color).style.background = "#525252";
              break;
          case "Rot":
              document.getElementById(color).style.background = "#9B2828";
              break;
          case "Apricot":
              document.getElementById(color).style.background = "#FFDDDD";
              break;
          case "Pink":
              document.getElementById(color).style.background = "#FF00EB";
              break;
          case "Aubergine":
              document.getElementById(color).style.background = "#A083B2";
              break;
          case "Koralle":
              document.getElementById(color).style.background = "#FF7E67";
              break;
          case "Flieder":
              document.getElementById(color).style.background = "#EACEFF";
              break;
          case "Neongelb":
              document.getElementById(color).style.background = "#FFE65A";
              break;
          case "Oliv":
              document.getElementById(color).style.background = "#707B53";
              break;
          case "Grün":
              document.getElementById(color).style.background = "#8DB598";
              break;
          case "Petrol":
              document.getElementById(color).style.background = "#198078";
              break;
          default:
              break;
      }

  }
}

function getColor(value) {
  switch (value) {
      case "Regenbogen":
          var color = "linear-gradient(to right,blue, red , yellow, green)";
          break;
      case "Nude":
          var color = "#E5D2C4";
          break;
      case "Altrosa":
          var color = "#cb7375";
          break;
      case "Dunkelgrau":
          var color = "#797b7a";
          break;
      case "Hellgrau":
          var color = "#C6C6C6";
          break;
      case "Schwarz":
          var color = "#000000";
          break;
      case "Anthrazit":
          var color = "#525252";
          break;
      case "Blau":
          var color = "#3E4E74";
          break;
      case "Dunkelblau":
          var color = "#3E4E74";
          break;
      case "Neonblau":
          var color = "#0333A5";
          break;
      case "Hellblau":
          var color = "#8FABED";
          break;
      case "Türkis":
          var color = "#1CB4C1";
          break;
      case "Rot":
          var color = "#9B2828";
          break;
      case "Apricot":
          var color = "#FFDDDD";
          break;
      case "Pink":
          var color = "#FF00EB";
          break;
      case "Aubergine":
          var color = "#A083B2";
          break;
      case "Koralle":
          var color = "#FF7E67";
          break;
      case "Flieder":
          var color = "#EACEFF";
          break;
      case "Neongelb":
          var color = "#FFE65A";
          break;
      case "Oliv":
          var color = "#707B53";
          break;
      case "Grün":
          var color = "#8DB598";
          break;
      case "Petrol":
          var color = "#198078";
          break;
      default:
          break;
  }

  return color;
}


$(document).ready(function() {
  var first_offset = $("#swap-first").offset();
  var second_offset = $("#swap-second").offset();
  setTimeout(function() {
    if(first_offset != undefined){
      $("#product-form-template--16483113238753__main .materialcolor1").css({
          top: first_offset.top + 60,
          left: first_offset.left
      });
    }
    if(second_offset != undefined){
      $("#product-form-template--16483113238753__main .materialcolor2").css({
          top: second_offset.top + 60,
          left: second_offset.left
      });
    }
  }, 2000);
  getColorName();
  $(".checkmark.optional2").click(function() {
      if (!$(this).closest(".flex-area").hasClass(".newjs")) {
          console.log('hasclass');
          if (jQuery(this).hasClass("checked")) {
              jQuery(this).removeClass("checked");
              jQuery(".plate2buchstabe.second-item, .plate2symbol.second-item").css("display", "none");
              jQuery("#pb3").css("background", "white");
              jQuery("#ps3").css("background", "white");
              jQuery(".activeletter").css("font-weight", "");
              $('.buchstabensymbol2-swatch input[value="' + $(".plate3-choice").text().split(" ")[0] + ' [ €10,00 ]"').trigger("click");
              $('.buchstabensymbol2-swatch-symbol input[value="' + $(".plate3-choice").text().split(" ")[0] + ' [ €10,00 ]"').trigger("click");
              jQuery(".plate3-choice").html("2. Plate (+10€)");
              $(".buchstabensymbol2-swatch > span").removeAttr('data-required');
              $(".buchstabensymbol2-swatch-symbol > span").removeAttr('data-required');

          } else {
              jQuery(this).addClass("checked");
              jQuery(".plate2buchstabe.second-item, .plate2symbol.second-item").css("display", "block");
          }
      } else {
          console.log('!hasclass');
          jQuery(this).toggleClass("checked");
          // jQuery(this).parent().parent().parent().find(".plate2buchstabe, .plate2symbol").toggle();

          jQuery(".plate2buchstabe.first-item, .plate2symbol.first-item").toggle();
      }

      jQuery(".main-symbol").addClass("db-block");
      jQuery(".lst-symbol").removeClass("db1-block");

      jQuery('.buchstabesymbol-wrapper').removeClass("active-bg");
      if (jQuery(this).hasClass("checked")) {
          jQuery(".wrapper-4").css('display', 'flex');
          jQuery(this).parent().parent().parent().addClass("active-bg");
      } else {
          jQuery(".main-symbol").removeClass("db-block");
          jQuery(".wrapper-4").hide();
          jQuery(this).parent().parent().parent().removeClass("active-bg");
          $('.buchstabensymbol2-swatch input[value="' + $(".plate3-choice").text().split(" ")[0] + ' [ €10,00 ]"').trigger("click");
          $('.buchstabensymbol2-swatch-symbol input[value="' + $(".plate3-choice").text().split(" ")[0] + ' [ €10,00 ]"').trigger("click");
          $('.buchstabensymbol3-swatch input[value="' + $(".plate4-choice").text().split(" ")[0] + ' [ €10,00 ]"').trigger("click");
          $('.buchstabensymbol3-swatch-symbol input[value="' + $(".plate4-choice").text().split(" ")[0] + ' [ €10,00 ]"').trigger("click");
          // jQuery(".plate3-choice").html(" - ");
          // jQuery(".plate4-choice").html(" - ");
      }
  })

  $(".checkmark.optional3").click(function() {
      if (!$(this).closest(".flex-area").hasClass(".newjs")) {
          console.log('hasclass');
          if (jQuery(this).hasClass("checked")) {
              jQuery(this).removeClass("checked");
              jQuery("#pb4").css("background", "white");
              jQuery("#ps4").css("background", "white");
              jQuery(".activeletter").css("font-weight", "");
              jQuery(".plate2buchstabe.second-item, .plate2symbol.second-item").css("display", "none");
              $('.buchstabensymbol3-swatch input[value="' + $(".plate4-choice").text().split(" ")[0] + ' [ €10,00 ]"').trigger("click");
              $('.buchstabensymbol3-swatch-symbol input[value="' + $(".plate4-choice").text().split(" ")[0] + ' [ €10,00 ]"').trigger("click");
              jQuery(".plate4-choice").html("3. Plate (+10€)");
              $(".buchstabensymbol3-swatch > span").removeAttr('data-required');
              $(".buchstabensymbol3-swatch-symbol > span").removeAttr('data-required');

          } else {
              jQuery(this).addClass("checked");
              jQuery(".plate2buchstabe.second-item, .plate2symbol.second-item").css("display", "block");
          }
      } else {
          console.log('!hasclass');
          jQuery(this).toggleClass("checked");
          // jQuery(this).parent().parent().parent().find(".plate2buchstabe, .plate2symbol").toggle();

          jQuery(this).parent().parent().parent().find(".plate2buchstabe, .plate2symbol").toggle();
      }
      jQuery('.buchstabesymbol-wrapper').removeClass("active-bg");
      if (!jQuery(this).hasClass("checked")) {
          $('.buchstabensymbol3-swatch input[value="' + $(".plate4-choice").text().split(" ")[0] + ' [ €10,00 ]"').trigger("click");
          $('.buchstabensymbol3-swatch-symbol input[value="' + $(".plate4-choice").text().split(" ")[0] + ' [ €10,00 ]"').trigger("click");
          // jQuery(".plate4-choice").html(" - ");
          //jQuery(this).parent().parent().parent().removeClass("active-bg");
          jQuery(".lst-symbol").removeClass("db1-block");

      } else {
          jQuery(this).parent().parent().parent().addClass("active-bg");

          jQuery(".main-symbol").removeClass("db-block");
          jQuery(".lst-symbol").addClass("db1-block");
      }
      // jQuery(this).parent().parent().parent().find(".plate2buchstabe, .plate2symbol").toggle();
      // jQuery(".plate2buchstabe.second-item, .plate2symbol.second-item").toggle();
      // jQuery(".main-symbol").removeClass("db-block");
      // jQuery(".lst-symbol").addClass("db1-block");

  })


  $(".checkmark.double-mark2").click(function() {
      if (!jQuery(".checkmark.double-mark5").hasClass("checked")) {
          jQuery(".second-main-symbol").addClass("second-main-symbol-first");
      }
      if (jQuery(this).hasClass("checked")) {
          jQuery(this).removeClass("checked");
          jQuery("#pb3").css("background", "white");
          jQuery("#ps3").css("background", "white");
          jQuery(".activeletter").css("font-weight", "");
          jQuery(".main-symbol").removeClass("db-block");
          jQuery(".lst-symbol").removeClass("db1-block");
          jQuery('.buchstabesymbol-wrapper').removeClass("active-bg");
          jQuery(".plate2buchstabe.first-item, .plate2symbol.first-item").css("display", "none");
          $('.buchstabensymbol2-swatch input[value="' + $(".plate3-choice").text().split(" ")[0] + ' [ €10,00 ]"').trigger("click");
          $('.buchstabensymbol2-swatch-symbol input[value="' + $(".plate3-choice").text().split(" ")[0] + ' [ €10,00 ]"').trigger("click");
          jQuery(".plate3-choice").html("2. Plate (+10€)");
          $(".buchstabensymbol2-swatch > span").removeAttr('data-required');
          $(".buchstabensymbol2-swatch-symbol > span").removeAttr('data-required');
      } else {
          jQuery(this).addClass("checked");
          var chk_Clos = $(this).closest('.double-flex');
          jQuery(".main-symbol").addClass("db-block");
          jQuery(".lst-symbol").removeClass("db1-block");

          jQuery('.buchstabesymbol-wrapper').removeClass("active-bg");
      }
      if (jQuery(this).hasClass("checked")) {
          jQuery(".wrapper-4").css('display', 'flex');

          jQuery(".first-main-symbol").removeClass("second-main-symbol-first");

          jQuery(this).parent().parent().parent().addClass("active-bg");
          jQuery(".materialcolor2").addClass("dropdown-padding");
      } else {
          jQuery(".main-symbol").removeClass("db-block");
          jQuery(".wrapper-4").hide();
          jQuery(this).parent().parent().parent().removeClass("active-bg");
          jQuery(".materialcolor2").removeClass("dropdown-padding");

      }
  })

  $(".checkmark.double-mark3").click(function() {
      if (!jQuery("checkmark.double-mark6").hasClass("checked")) {
          jQuery(".second-lst-symbol").addClass("second-main-symbol-first");
      }

      if (jQuery(this).hasClass("checked")) {
          jQuery(this).removeClass("checked");
          jQuery("#pb4").css("background", "white");
          jQuery("#ps4").css("background", "white");
          jQuery(".activeletter").css("font-weight", "");
          jQuery(".main-symbol").removeClass("db-block");
          jQuery(".lst-symbol").removeClass("db1-block");
          jQuery('.buchstabesymbol-wrapper').removeClass("active-bg");
          jQuery(".plate2buchstabe.second-item, .plate2symbol.second-item").css("display", "none");
          $('.buchstabensymbol3-swatch input[value="' + $(".plate4-choice").text().split(" ")[0] + ' [ €10,00 ]"').trigger("click");
          $('.buchstabensymbol3-swatch-symbol input[value="' + $(".plate4-choice").text().split(" ")[0] + ' [ €10,00 ]"').trigger("click");
          jQuery(".plate4-choice").html("3. Plate (+10€)");
          $(".buchstabensymbol3-swatch > span").removeAttr('data-required');
          $(".buchstabensymbol3-swatch-symbol > span").removeAttr('data-required');
      } else {
          jQuery(this).addClass("checked");
          jQuery('.buchstabesymbol-wrapper').removeClass("active-bg");

          jQuery(".materialcolor2").addClass("dropdown-padding");
      }
      if (!jQuery(this).hasClass("checked")) {

          jQuery(this).parent().parent().parent().removeClass("active-bg");

          jQuery(".lst-symbol").removeClass("db1-block");
          jQuery(".materialcolor2").removeClass("dropdown-padding");
      } else {
          jQuery(this).parent().parent().parent().parent().addClass("active-bg");

          jQuery(".main-symbol").removeClass("db-block");
          jQuery(".lst-symbol").addClass("db1-block");
          jQuery(".first-lst-symbol").removeClass("second-main-symbol-first");

      }


  })


  $(".checkmark.double-mark5").click(function() {
      if (!jQuery(".checkmark.double-mark2").hasClass("checked")) {
          jQuery(".first-main-symbol").addClass("second-main-symbol-first");
      }

      if (jQuery(this).hasClass("checked")) {
          jQuery(this).removeClass("checked");
          jQuery("#pb6").css("background", "white");
          jQuery("#ps6").css("background", "white");
          jQuery(".activeletter").css("font-weight", "");
          jQuery(".main-symbol").removeClass("db-block");
          jQuery(".second-main-symbol").removeClass("second-main-symbol-first");
          jQuery(this).parent().parent().parent().removeClass("active-bg");
          jQuery(".lst-symbol").removeClass("db1-block");
          jQuery('.buchstabesymbol-wrapper').removeClass("active-bg");
          $('.buchstabensymbol5-swatch input[value="' + $(".plate6-choice").text().split(" ")[0] + ' [ €10,00 ]"').trigger("click");
          $('.buchstabensymbol5-swatch-symbol input[value="' + $(".plate6-choice").text().split(" ")[0] + ' [ €10,00 ]"').trigger("click");
          jQuery(".plate6-choice").html("2. Plate (+10€)");
          $(".buchstabensymbol5-swatch > span").removeAttr('data-required');
          $(".buchstabensymbol5-swatch-symbol > span").removeAttr('data-required');
      } else {
          jQuery(this).addClass("checked");

          // jQuery(this).parent().parent().parent().find(".plate2buchstabe, .plate2symbol").toggle();
          jQuery(".second-main-symbol").removeClass("second-main-symbol-first");
          jQuery(".main-symbol").addClass("db-block");
          jQuery(".lst-symbol").removeClass("db1-block");

          jQuery('.double-3rd-plate-bottom').removeClass("active-bg");
      }

      if (jQuery(this).hasClass("checked")) {
          jQuery(".wrapper-4").css('display', 'flex');
          jQuery(this).parent().parent().parent().addClass("active-bg");
      } else {
          jQuery(".main-symbol").removeClass("db-block");
          jQuery(".second-wrapper-4").hide();
          // jQuery(this).parent().parent().parent().removeClass("active-bg");

      }
  })

  $(".checkmark.double-mark6").click(function() {

      if (!jQuery(".checkmark.double-mark3").hasClass("checked")) {
          jQuery(".first-lst-symbol").addClass("second-main-symbol-first");
      }

      if (jQuery(this).hasClass("checked")) {
          jQuery(this).removeClass("checked");
          jQuery("#pb7").css("background", "white");
          jQuery("#ps7").css("background", "white");
          jQuery(".activeletter").css("font-weight", "");
          jQuery(".main-symbol").removeClass("db-block");
          jQuery(".lst-symbol").removeClass("db1-block");
          jQuery('.buchstabesymbol-wrapper').removeClass("active-bg");
          $('.buchstabensymbol6-swatch input[value="' + $(".plate7-choice").text().split(" ")[0] + ' [ €10,00 ]"').trigger("click");
          $('.buchstabensymbol6-swatch-symbol input[value="' + $(".plate7-choice").text().split(" ")[0] + ' [ €10,00 ]"').trigger("click");
          jQuery(".plate7-choice").html("3. Plate (+10€)");
          $(".buchstabensymbol6-swatch > span").removeAttr('data-required');
          $(".buchstabensymbol6-swatch-symbol > span").removeAttr('data-required');
      } else {
          jQuery(this).addClass("checked");
          jQuery('.double-buchstabesymbol-wrapper').removeClass("active-bg");
      }


      if (!jQuery(this).hasClass("checked")) {

          jQuery(this).parent().parent().parent().parent().removeClass("active-bg");
          jQuery(".lst-symbol").removeClass("db1-block");
      } else {
          jQuery(this).parent().parent().parent().parent().addClass("active-bg");

          jQuery(".main-symbol").removeClass("db-block");
          jQuery(".lst-symbol").addClass("db1-block");
          jQuery(".second-lst-symbol").removeClass("second-main-symbol-first");
      }


  })


  /* CLICK OPTIONS */
  $(".doublebutton").click(function() {
      $(".full-width-pop").css("display", "flex");
      $("body").css("overflow", "hidden");
  });

    /* SHOW ONLY ONE DROPDOWN */
  $("#dropdown-bandgröße-0").click(function(e) {
    $("#dropdown-content1").hide();
  });

  $("#ringsizewrapper").click(function() {
    $(".ringsize-swatches").toggleClass("activeDrop");
   });
    
   $("#ringstonewrapper").click(function() {
    $(".ringstone-swatches").toggleClass("activeDrop");
    });

  $(".odv_reset_button").click(function() {
    $('.dropdown-content-class[val="Poliert"]').trigger('click');
    $('.dropdown-content-class[val="zart"]').trigger('click');
    jQuery('.ringstone-swatches input[value="Nein"]').trigger('click');
    $('.ringstone-choice').html("Nein");
    jQuery('.ringsymbol-swatches input[value="Kein Symbol"]').parent().trigger('click');
    jQuery("#ringtext").val("");
    jQuery("#ringtext").trigger("change");
    jQuery("#dropdown-bandgröße-0 .dropdown-wrapper").css("background-color","unset");
    jQuery("#dropdown-bandgröße-1 .dropdown-wrapper").css("background-color","unset");
    jQuery("#ringstonewrapper").css("background-color","unset");
    jQuery("#ringsizewrapper").css("background-color","unset");
    jQuery("#ringsymbolwrapper").css("background-color","unset");
    jQuery("#ringfontwrapper").css("background-color","unset");
    jQuery("#ringsize").html("Größe");
    $('.ringstone-swatches label.avp-productoptionswatchwrapper:nth-child(2)').trigger('click');
    if($("#ringgravurwrapper #ringgravur").html() == "Gravur entfernen") {
        $("#ringgravurwrapper").click();
        jQuery("#ringsymbolwrapper, #ringtextwrapper, #ringfontwrapper").addClass("odv_hide");
        jQuery('.gravur input[value="Nein"]').trigger('click');
    }
    });

  /* BANDFARBE */
  $(".dropdown-bandgröße").click(function(e) {
      e.stopPropagation();
      var counter = $(this).attr("counter");
      var dc = "#dropdown-content" + counter;
      $(dc).toggle();
  });

  $(".product-form__input input[name='Bandfarbe']").click(function() {
    var farbe = $(this).attr("value");
});

  $(".inputwrapper-bandgröße").click(function(e) {
      var val = $(this).attr("val");
      $(".dropdown-bandgröße > div > .buchstabeonly-choice").html(val);
      /* ring removal
      if (window.location.href.includes("ring-edition")) {
          setRingProductImage();
      } else {*/
          swiper2.slideTo(jQuery('.swiper-slide[data-var="' + val + '"]').attr("data-nr"), 0)
      //}
      e.stopPropagation();
      $(this).parent().hide();
  });

  $(".inputwrapper-kettengröße").click(function(e) {
    jQuery("#valentinstag-set-buchstabe-halskette-armband .dropdown-content-bandgröße").hide();
    var val = $(this).attr("val");
    var farbe = $(this).attr("val");
    if(jQuery("#dropdown-name1").html() == "Bandfarbe") {
        var color = "Nude";
    } else {
        var color = jQuery("#dropdown-name1").html();
    }
    $(".dropdown-bandgröße > div > .kette-choice").html(val);
    /* ring removal
    if (window.location.href.includes("ring-edition")) {
        setRingProductImage();
    } else*/ if(window.location.href.includes("armkette-buchstabe")) {
        
    } else if($(".headfont").text().includes("Valentinstag-Set Buchstabe Armkette/Halskette") ){
        if($(".headfont").text().includes("Valentinstag-Set Buchst")) {
            if ($('input[value=Silber]').is(':checked')) {
                var material = "Silber";
            } else if ($('input[value=Gold]').is(':checked')) {
                var material = "Gold";
            } else if ($('input[value=Rosé]').is(':checked')) {
                var material = "Rose";
            }
            var searchClass = ".odv_symbol.odv_variant." + material;
            swiper2.slideTo(jQuery(searchClass).parent().attr("data-nr")-1, 0);
        }
    } else if($(".headfont").text().includes("Valentinstag-Set Buchstabe Armband/Halskette")){
        if($(".headfont").text().includes("Valentinstag-Set Buchst")) {
       
        } else {
        if ($('input[value=Silber]').is(':checked')) {
            var material = "Silber";
        } else if ($('input[value=Gold]').is(':checked')) {
            var material = "Gold";
        } else if ($('input[value=Rosé]').is(':checked')) {
            var material = "Rose";
        }
        var searchClass = ".odv_symbol.odv_variant." + material + "." + farbe;
        swiper2.slideTo(jQuery(searchClass).parent().attr("data-nr")-1, 0);
        }
      } else if($(".headfont").text().includes("Armband - Buchstabe")){
        var searchClass = ".odv_symbol.odv_variant." + color + "." + farbe;
      } else {
        if($(".headfont").text().includes("Valentinstag-Set") && $(".headfont").text().includes("Armkette")) {

        } else if($(".headfont").text().includes("Armband -") && $(".product").hasClass("new_product")) {

        } else if($(".headfont").text().includes("Sternzeichen-Armband") && $(".product").hasClass("new_product")) {

        } else if($(".headfont").text().includes("Kette -") && $(".product").hasClass("new_product")) {

        } else if($(".headfont").text().includes("Sternzeichen-Set") && $(".product").hasClass("new_product")) {

        } else if($(".headfont").text().includes("Sternzeichen-Kette") && $(".product").hasClass("new_product")) {

        } else {
            swiper2.slideTo(jQuery('.swiper-slide[data-var="' + val + '"]').attr("data-nr"), 0)
        }
        if($(".headfont").text().includes("Valentinstag-Se")) {
            jQuery(".inputwrapper[val='" + jQuery('#dropdown-name1').html() + "']").click();
        }
    }
    e.stopPropagation();
    $(this).parent().hide();
     if(jQuery(".material-labelGold").hasClass("activebutton")) {
    materialclickGold();
  }
});
  

  /*new*/
  jQuery(".inputwrapper-bandgröße").click(function(e) {
      var val = jQuery(this).attr("val");
      var choiceZero = jQuery('#dropdown-bandgröße-0 .choice').text();
      var choiceOne = jQuery('#dropdown-bandgröße-1 .choice').text();
      if (choiceZero == " - ") {
          choiceZero = jQuery("#dropdown-bandgröße-0 .dropdown-content-bandgröße .inputwrapper-bandgröße input").first().val();
      }
      if (choiceOne == " - ") {
          choiceOne = jQuery("#dropdown-bandgröße-1 .dropdown-content-bandgröße .inputwrapper-bandgröße input").first().val();
      }


      jQuery(this).parent().parent().find(".choice").html(val);
      jQuery(".odv_oberflaeche").hide();
      jQuery('.odv_' + choiceOne.toLowerCase()).show();

      /* ring removal
      if (window.location.href.includes("ring-edition")) {
          setRingProductImage();
      } else {*/
          swiper2.slideTo(jQuery('img[data-var-title="' + choiceZero + ' / ' + choiceOne + '"]').parent().attr("data-nr"), 0);
      //}
  });
  /*endnew*/

  $(".dropdown").click(function(e) {
      e.stopPropagation();
      var counter = $(this).attr("counter");
      // console.log('counter: '+counter);
      var dc = "#dropdown-content" + counter;
      // var d_width= $(".dropdown").width();
      // var d_offset= $(".dropdown").offset();
      // console.log('width: '+d_width+' offset top: '+d_offset.top+' offset left: '+d_offset.left);
      // $("#dropdown-content"+counter).css({width:d_width, top: d_offset.top, left: d_offset.left, position:'initial'});
      $(dc).toggle();
  });


  $(".inputwrapper").click(function(e) {
      $(".dropdown-wrapper>.circle-wrapper").css("display", "inline-block");
      var counter = $(this).attr("counter");
      var selec = "#dropdown-name" + counter;
      var val = $(this).attr("val");
      var color = getColor(val);
      var farbe = $(this).attr("val");
      if(farbe.includes("ü")){
        farbe = farbe.replace("ü","ue");
      }
      $("#mainbtn").css("background", color);
      $(selec).html(val);
      $(selec).parent().parent().parent().addClass("active-bg");
      e.stopPropagation();
      $(this).parent().hide();
      /* ring removal
      if (window.location.href.includes("ring-edition")) {
          setRingProductImage();
      } else*/ if($(".headfont").text().includes("Valentins") || $(".headfont").text().includes("Sternzeichen-Set")){
        if($(".headfont").text().includes("Valentinstag-Set Buchst") ) {
            var searchClass = ".odv_symbol.odv_variant." + farbe + ".A";
            swiper2.slideTo(jQuery(searchClass).parent().attr("data-nr")-1, 0);
        } else {
        if ($('input[value=Silber]').is(':checked')) {
            var material = "Silber";
        } else if ($('input[value=Gold]').is(':checked')) {
            var material = "Gold";
        } else if ($('input[value=Rosé]').is(':checked')) {
            var material = "Rose";
        }
        var searchClass = ".odv_symbol.odv_variant." + material + "." + farbe;
        swiper2.slideTo(jQuery(searchClass).parent().attr("data-nr")-1, 0);
        }
      } else if($(".headfont").text().includes("Sternzeichen-Armband") || $(".headfont").text().includes("Fußkettchen") || $(".headfont").text().includes("Armband -") && $(".product").hasClass("new_product")){
        if($(".headfont").text().includes("Armband - Buchstabe") && $(".product").hasClass("new_product")){
            if ($(".odv_buchstaben_switch span.dropdown-name").text().includes("Silber")) {
                var material = "Silber";
            } else if ($(".odv_buchstaben_switch span.dropdown-name").text().includes("gelb")) {
                var material = "Gold";
            } else if ($(".odv_buchstaben_switch span.dropdown-name").text().includes("rosé")) {
                var material = "Rose";
            }
            var searchClass = ".odv_symbol." + material + "." + farbe;
            console.log(searchClass);
            swiper2.slideTo(jQuery(searchClass).parent().attr("data-nr")-1, 0);
        } else if($(".headfont").text().includes("Fußkettchen Buchstabe") && $(".product").hasClass("new_product")){
            var searchClass = ".odv_symbol.Silber." + farbe;
            console.log(searchClass);
            swiper2.slideTo(jQuery(searchClass).parent().attr("data-nr")-1, 0);
        } else {
        if ($('input[value=Silber]').is(':checked')) {
            var material = "Silber";
        } else if ($('input[value=Gold]').is(':checked')) {
            var material = "Gold";
        } else if ($('input[value=Rosé]').is(':checked')) {
            var material = "Rose";
        }        
        var searchClass = ".odv_symbol." + material + "." + farbe;
        console.log(searchClass);
        swiper2.slideTo(jQuery(searchClass).parent().attr("data-nr")-1, 0);
        }
    } else {
          swiper2.slideTo(jQuery('img[data-var-title="' + jQuery(".activebutton").parent().attr("id") + ' / ' + jQuery("#dropdown-name1").text() + '"]').parent().attr("data-nr"))
      }
  });

function change_img_preview_background(letter) {
  var tag = '{{ pro_tag }}';
  if (tag == "buchstaben_swipe") {
      var value = $(".material-wrapper > input:checked").val();

      switch (letter) {
          case "A":
              if (value == "Gold") {
                  $(".mySwiper2 > .swiper-wrapper > .swiper-slide:first>img").attr('src', '{{section.settings.A-Gold}}');
              } else if (value == "Silber") {
                  $(".mySwiper2 > .swiper-wrapper > .swiper-slide:first>img").attr('src', '{{section.settings.A-Silber}}');
              } else {
                  $(".mySwiper2 > .swiper-wrapper > .swiper-slide:first>img").attr('src', '{{section.settings.A-Rose}}');
              }
          case "B":
              break;
      }

      /* ring removal
      if (window.location.href.includes("ring-edition")) {
          setRingProductImage();
      } else { */
          swiper2.slideTo(0, 0);
      //}
  }
}

function change_img_preview_background2(letter, material) {
  var value = material;

  switch (letter) {
      case "A":
          if (value == "Gold") {
              $(".mySwiper2 > .swiper-wrapper > .swiper-slide:first>img").attr('src', '{{section.settings.A-Gold}}');
          } else if (value == "Silber") {
              $(".mySwiper2 > .swiper-wrapper > .swiper-slide:first>img").attr('src', '{{section.settings.A-Silber}}');
          } else {
              $(".mySwiper2 > .swiper-wrapper > .swiper-slide:first>img").attr('src', '{{section.settings.A-Rose}}');
          }
      case "B":
          break;
  }

  /* ring removal
  if (window.location.href.includes("ring-edition")) {
      setRingProductImage();
  } else { */
      swiper2.slideTo(0, 0);
  //}
}


$("#Gold").click(function() {
  var tag = '{{ pro_tag }}';
  if (tag == "buchstaben_swipe") {
      var active = $(".activeletter").first().html();
      if (active == undefined) {
          change_img_preview_background2("A", "Gold");
      } else {
          change_img_preview_background2(active, "Gold");
      }
  } else {
      var odv_check = "Gold"
      //jQuery(".mySwiper2 .swiper-slide").each(function(){if (odv_check == (jQuery(this).attr("data-var"))){swiper2.slideTo(parseInt(jQuery(this).attr("data-nr")), 0)}});

  }
});

$("#Silber").click(function() {
  var tag = '{{ pro_tag }}';
  if (tag == "buchstaben_swipe") {
      var active = $(".activeletter").first().html();
      if (active == undefined) {
          change_img_preview_background2("A", "Silber");
      } else {
          change_img_preview_background2(active, "Silber");
      }
  } else {
      var odv_check = "Silber"
      //jQuery(".mySwiper2 .swiper-slide").each(function(){if (odv_check == (jQuery(this).attr("data-var"))){swiper2.slideTo(parseInt(jQuery(this).attr("data-nr")), 0)}});

  }
});

$("#Rosé").click(function() {
  var tag = '{{ pro_tag }}';
  if (tag == "buchstaben_swipe") {
      var active = $(".activeletter").first().html();
      if (active == undefined) {
          change_img_preview_background2("A", "Rosé");
      } else {
          change_img_preview_background2(active, "Rosé");
      }
  } else {
      var odv_check = "Rosé"
      //jQuery(".mySwiper2 .swiper-slide").each(function(){if (odv_check == (jQuery(this).attr("data-var"))){swiper2.slideTo(parseInt(jQuery(this).attr("data-nr")), 0)}});

  }
});



var options = $('.vodiapicker option');

$(options[6]).insertAfter($(options[0]));
$(options[2]).insertAfter($(options[3]));

var options = $('.vodiapicker option');

$(options[7]).insertAfter($(options[1]));

var options = $('.vodiapicker option');

$(options[8]).insertAfter($(options[2]));

var options = $('.vodiapicker option');

$(options[9]).insertAfter($(options[3]));

var options = $('.vodiapicker option');

$(options[10]).insertAfter($(options[4]));

var options = $('.vodiapicker option');

$(options[11]).insertAfter($(options[5]));

var options = $('.vodiapicker option');

$(options[12]).insertAfter($(options[6]));

var options = $('.vodiapicker option');

$(options[13]).insertAfter($(options[7]));
var options = $('.vodiapicker option');

$(options[11]).insertAfter($(options[9]));

var options = $('.vodiapicker option');

$(options[11]).insertAfter($(options[8]));})

/* ring removal
function setRingProductImage() {
  let material;
  let form;
  let oberflaeche;
  let groese;
  let stein;
  let gravur;
  if (jQuery(".caption-with-letter-spacing").text().includes("585er Gold")) {
      material = "ge";
  } else if (jQuery(".caption-with-letter-spacing").text().includes("Platin")) {
      material = "pl";
    } else if (jQuery(".caption-with-letter-spacing").text().includes("Silber")) {
      material = "si";
  } else {
      material = "ro";
  }
  if (jQuery(".headfont").text().includes("SMOOTH")) {
      form = "_ov";
  } else if (jQuery(".headfont").text().includes("PURE")) {
      form = "_rd";
  } else {
      form = "_hh";
  }
  if (jQuery("#dropdown-bandgröße-0 .choice").text().includes("klassisch")) {
      groese = "_m";
  } else if (jQuery("#dropdown-bandgröße-0 .choice").text().includes("massiv")) {
      groese = "_l";
  } else {
      groese = "_s";
  }
  if (jQuery("#dropdown-bandgröße-1 .choice").text().includes("Feinmatt")) {
      oberflaeche = "_fm";
  } else if (jQuery("#dropdown-bandgröße-1 .choice").text().includes("Hammerschlag")) {
      oberflaeche = "_hs";
  } else {
      oberflaeche = "_po";
  }
  if (jQuery(".ringstone-choice").text().includes("Ja")) {
      stein = "_ms";
  } else {
      stein = "_os";
  }
  if (jQuery("#ringsymbolwrapper").hasClass("odv_hide")) {
      gravur = "";
  } else {
      if ((jQuery(".ringsymbol-choice").text().includes("-") || jQuery(".ringsymbol-choice").text().includes("Kein Symbol")) && jQuery(".ringfont-choice").text().includes("-")) {
          gravur = "_g_book_antiqua";
      }
      if (jQuery(".ringsymbol-choice").text().includes("-") || jQuery(".ringsymbol-choice").text().includes("Kein Symbol")) {
          if (jQuery(".ringfont-choice").text().includes("Book Antiqua")) {
              gravur = "_g_book_antiqua";
          } else {
              gravur = "_g_lucida_handwriting";
          }
      } else {
          if (jQuery(".ringsymbol-choice").text().includes("Doppel Herz")) {
              gravur = "_g_doppelt_herz";
          } else if (jQuery(".ringsymbol-choice").text().includes("Doppel Ring")) {
              gravur = "_g_doppelt_ring";
          } else if (jQuery(".ringsymbol-choice").text().includes("Herz")) {
              gravur = "_g_herz";
          } else if (jQuery(".ringsymbol-choice").text().includes("Infinity")) {
              gravur = "_g_infinity";
          } else if (jQuery(".ringsymbol-choice").text().includes("Luck")) {
              gravur = "_g_luck";
          } else {
              gravur = "_g_yingyang";
          }
      }

  }
  let url = "https://cdn.shopify.com/s/files/1/0647/9393/6097/files/" + material + oberflaeche + form + groese + stein + gravur + "_x1000.png";
  jQuery(".productImageSwiper img").first().attr("src", url);
  swiper2.slideTo(0, 0);
// wenn zart geklickt -> Hammerschlag ausblenden + falls Hammerschlag gewählt zu Poliert switchen, wenn klassisch/massiv -> Hammerschlag einblenden
if (jQuery("#dropdown-bandgröße-0 .choice").text().includes("zart")) {
    jQuery('.inputwrapper-bandgröße[val="Hammerschlag"]').hide();
    if (jQuery("#dropdown-bandgröße-1 .choice").text() == "Hammerschlag") {
        jQuery("#dropdown-content1 input").first().trigger("click");
    }
  } else {
    jQuery('.inputwrapper-bandgröße[val="Hammerschlag"]').show();
  }
// wenn Hammerschlag geklickt -> zart ausblenden + wenn feinmatt/poliert -> zart einblenden
  if (jQuery("#dropdown-bandgröße-1 .choice").text().includes("Hammerschlag")) {
    jQuery('.inputwrapper-bandgröße[val="zart"]').hide();
  } else {
    jQuery('.inputwrapper-bandgröße[val="zart"]').show();
  }

// wenn pure und zart geklickt -> Stein und Gravur ausblenden und ggfs. abwählen
  if (jQuery("#dropdown-bandgröße-0 .choice").text().includes("zart") && jQuery(".headfont").text().includes("PURE")) {
    jQuery("#ringstonewrapper").hide();
    if(jQuery('.ringstone-swatches input[value="Nein"]').is(":checked") == false){
        jQuery('.ringstone-swatches input[value="Nein"]').trigger('click');
    }
    jQuery(".ringstone-choice").text("Nein");
// wenn kind/zart -> Stein ausblenden und ggfs. abwählen
  } else if (jQuery("#dropdown-bandgröße-0 .choice").text().includes("zart") && jQuery(".headfont").text().includes("SMOOTH")) { 
    jQuery("#ringstonewrapper").hide();
    if(jQuery('.ringstone-swatches input[value="Nein"]').is(":checked") == false){
        jQuery('.ringstone-swatches input[value="Nein"]').trigger('click');
    }
    jQuery(".ringstone-choice").text("Nein");
  } else {
    jQuery("#ringstonewrapper").show();
  }
  if (jQuery("#dropdown-bandgröße-0 .choice").text().includes("zart") && jQuery(".headfont").text().includes("PURE")) {
    jQuery("#ringsymbolwrapper, #ringtextwrapper, #ringfontwrapper").addClass("odv_hide");
    if(jQuery('.gravur input[value="Ja [ €40,00 ]"]').is(":checked") == true){
        jQuery('.gravur input[value="Nein"]').trigger('click');
    }
    jQuery('#ringgravurwrapper').hide();
// wenn kind/zart -> Gravur ausblenden und ggfs. abwählen
  } else if (jQuery("#dropdown-bandgröße-0 .choice").text().includes("zart") && jQuery(".headfont").text().includes("SMOOTH")) {
    jQuery("#ringsymbolwrapper, #ringtextwrapper, #ringfontwrapper").addClass("odv_hide");
    if(jQuery('.gravur input[value="Ja [ €40,00 ]"]').is(":checked") == true){
        jQuery('.gravur input[value="Nein"]').trigger('click');
    }
    jQuery('#ringgravurwrapper').hide();
  } else {
    jQuery('#ringgravurwrapper').show();
  }
  if((jQuery(".ringsymbol-choice").text().includes("Kein Symbol") || jQuery(".ringsymbol-choice").text().includes("-")) && jQuery("#ringtext").val() == ""){
    if(jQuery('.gravur input[value="Ja [ €40,00 ]"]').is(":checked") == true ){
        jQuery('.gravur input[value="Nein"]').trigger('click');
    }
  } else {
    if(jQuery('.gravur input[value="Ja [ €40,00 ]"]').is(":checked") == false){
        jQuery('.gravur input[value="Ja [ €40,00 ]"]').trigger('click');
    }
  }


}
jQuery("#ringtext").change(function(){setRingProductImage();})
*/

$(document).click(function(event) { 
if(!$(event.target).closest('.dropdown-content').length) {
    $('.dropdown-content').hide();
}        
});
$(document).click(function(event) { 
if(!$(event.target).closest('.dropdown-content-bandgröße').length) {
    $('.dropdown-content-bandgröße').hide();
}        
});

//$("[val = Nude]").hide();


$(window).on("load", function(){
  $('.odv_symbol_img').each(function() {
    if (this.complete && typeof this.naturalWidth !== "undefined" && this.naturalWidth === 0) {
      $(this).hide();
    }
  });
});